import React, { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext();

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    return {
      sidebarOpen: false,
      setSidebarOpen: () => {},
      toggleSidebar: () => {},
      showSidebarToggle: false,
    };
  }
  return context;
};

export const SidebarProvider = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    // Check if window is available (client-side) and screen width
    if (typeof window !== 'undefined') {
      return window.innerWidth >= 1024; // lg breakpoint
    }
    return true; // Default to open for SSR
  });

  const [manualSidebarControl, setManualSidebarControl] = useState(false);
  const [showSidebarToggle, setShowSidebarToggle] = useState(false);

  // Handle responsive sidebar behavior
  useEffect(() => {
    const handleResize = () => {
      const isLargeScreen = window.innerWidth >= 1024;
      
      // Only auto-adjust if user hasn't manually controlled the sidebar
      if (!manualSidebarControl) {
        setSidebarOpen(isLargeScreen);
      }
    };

    // Add resize listener
    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, [manualSidebarControl]);

  const toggleSidebar = () => {
    console.log('📱 Toggling sidebar from header - BEFORE:', { sidebarOpen, manualSidebarControl });
    setManualSidebarControl(true);
    setSidebarOpen(prev => {
      const newValue = !prev;
      console.log('📱 Setting sidebar to:', newValue);
      return newValue;
    });
  };

  const value = {
    sidebarOpen,
    setSidebarOpen,
    toggleSidebar,
    manualSidebarControl,
    setManualSidebarControl,
    showSidebarToggle,
    setShowSidebarToggle,
  };

  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  );
};